import {PrivateCommand} from "../PrivateCommand";
import cmp, {site} from "../../../context/context";
import Client from "../../../client/client";
import AnalyticManager from "../../../analytic/analytic-manager";
import {EAction, ELabel} from "../../../analytic/event-definition";
import {UIEvent} from "../../../ui/u-i-event";
import {TEvent} from "services-comun-meteored/modules/services/cmp/web/events";
import {UIManager} from "../../../ui/u-i-manager";

export class RejectAndSaveConsents extends PrivateCommand {

    public override execute(_?: string, callback?: (result: boolean) => void) {
        if (site.gdprParams()?.['cap_reject_all'] == '1' && (!site.insistModeConfig()?.e || Client().premium)) {
            // Rechazamos los consentimientos
            cmp().rejectAll();

            // Lanzamos evento analítico
            AnalyticManager().register({
                action: EAction.GDPR,
                label: ELabel.RECHAZAR_GLOBAL
            });

            // Lanzamos el evento de finalización
            const event = UIEvent.create(TEvent.FINALIZAR);
            event.register();
            event.notify();

            // Cerrar ventanas del CMP
            UIManager.closeWindows();

            callback?.(true);
        } else {
            callback?.(false);
        }
    }
}
